import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './FishingLicenceInformation.module.scss'
import { fishingVesselAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const FishingVessel = ({ t, validateFishingVessel, fishingVesselError, fishingVesselValid, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const fishingVessel = useSelector((state) => state.app.fishingVessel)

  const handleFishingVessel = (e) => {
    try {
      let name = e.currentTarget.value
      dispatch(fishingVesselAction(name))
      validateFishingVessel(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurFishingVessel = (e) => {
    try {
      let name = e.currentTarget.value.trim()
      SetIsFocussed(false)
      dispatch(fishingVesselAction(name))
      validateFishingVessel(fishingVessel)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <div
      className={[
        fishingVesselValid === true ? (fishingVessel === '' ? '' : 'form-group has-success') : fishingVesselValid === false ? 'form-group has-error ns-form-group-message-error' : '',
        styles['fields_margin'],
      ].join(' ')}
    >
      <label className="control-label" htmlFor="FishingVessel">
        {t('fishing_licence_info.fishing_vessel')}
      </label>
      {fishingVesselValid === false && (
        <div className="ns-form-error-container">
          <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(fishingVesselError)}</div>
        </div>

      )}
      <input
        type="text"
        id="FishingVessel"
        className="form-control"
        value={fishingVessel}
        onChange={handleFishingVessel}
        onBlur={onBlurFishingVessel}
        onFocus={() => SetIsFocussed(true)}
        autoComplete="off"
        maxLength="7"
      />
      {fishingVesselValid === true &&
        fishingVessel !== '' && (
          <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
        )}
    </div>
  )
}

export default withTranslation('common')(FishingVessel)
